/**
 * @license
 *-------------------------------------------------------------------------------------------
 * Copyright © 2025 Progress Software Corporation. All rights reserved.
 * Licensed under commercial license. See LICENSE.md in the package root for more information
 *-------------------------------------------------------------------------------------------
 */
var i = /* @__PURE__ */ ((n) => (n.incell = "incell", n.inline = "inline", n))(i || {});
export {
  i as NavigatableMode
};
